// @core/api/endpoints/localization/list_translation_keys.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListTranslationKeysResponse,
} from '../../../types/localization';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/localization';

/**
 * List translation keys
 * Returns translation keys with filtering by namespace, status, tags, and search.
 */
export async function ListTranslationKeys(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListTranslationKeysResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/localization/keys`;
  const requestOptions = options;
  return client.get<ListTranslationKeysResponse>(requestPath, { ...requestOptions, params });
}
